import { useQuery } from "@tanstack/react-query"
import { Guid } from "../app/models/CustomType"
import { DeviceRoleGet } from "../app/models/DeviceRole"
import { digitalManagerApi } from "../services/api"

export function useDeviceRoles(deviceId?: Guid) {
  const { data: deviceRoles = [], isLoading: isLoadingDeviceRoles } = useQuery({
    queryKey: ["deviceRoles", deviceId],
    queryFn: () =>
      digitalManagerApi
        .get<DeviceRoleGet[]>(`/devices/${deviceId}/roles`)
        .then((r) => r.data),
    enabled: !!deviceId,
  })

  return {
    deviceRoles,
    isLoadingDeviceRoles,
  }
}
